// 物码查询
<template>
  <div id="containt" style="padding-left: 10px;">

    <div class="grid-height" style=" height: calc(100vh - -77px);">
      <vxe-grid align="center" :span-method="mergeRowMethod" show-overflow :stripe="true" :border="true" height="100%"
        :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
        @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

        <template #form>
          <div class="clearfix screen-btns" style="margin-top: 3px;">
            <div class="fl">
              <vxe-button v-if="item_barcode_search_report_export" status="primary" class="button-sty" icon="el-icon-plus" @click="doExcel">导出</vxe-button>
            </div>
            <div class="fr">
              <!--									<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
              <!--										status="primary" plain>重置</vxe-button>-->
              <vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
            </div>
          </div>
          <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
            @submit="searchEvent" @reset="searchEvent">
            <vxe-form-item title="产品条码:" field="name">
              <template v-slot>
                <el-input v-model="formData.itemBarcode" size="small" clearable />
              </template>
            </vxe-form-item>
            <vxe-form-item title="配件条码:" field="name">
              <template v-slot>
                <el-input v-model="formData.partsBarcode" size="small" clearable />
              </template>
            </vxe-form-item>
          </vxe-form>
        </template>
        <!-- 分页器 -->
        <template #pager>
          <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
        </template>
      </vxe-grid>
    </div>

  </div>
</template>

<script>
import { initVxeTable } from '@/const/crud/admin/table'
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import {mapGetters} from "vuex";


export default {
  name: 'barcodeSearch',

  components: { pager },
  data() {
    return {
      item_barcode_search_report_export: false,
      getPageDataUrl: '/basic/basCompanyBarcode/getListPage',
      showEdit: false,
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      pageSizes: [100, 200, 500],
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 10,  // 页面数据量

        itemBarcode: null,
        partsBarcode: null,
      },
      formData: {
        itemBarcode: null,
        partsBarcode: null,
      },
      searchBarcode: '',
      searchItemCode: '',
      searchItemName: '',
      total: 0,  // 数据总数
      vxeOption: {},
      columns: [
        // { type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },
        {
          title: '生产信息',
          children: [
            { title: '产品条码', field: 'itemBarcode', width: 150, },
            { title: '制造商', field: 'produceCompany', width: 110, },
            { title: '产品编码', field: 'itemCode', width: 150, },
            { title: '产品名称', field: 'itemName', width: 110, },
            { title: '生产批次', field: 'produceNo', width: 120, },
            { title: '产线', field: 'produceLine', width: 110, },
          ]
        },

        {
          title: '销售信息',
          children: [
            { title: '配件码', field: 'itemBarcode', width: 100, },
            { title: '配件编码', field: 'partsCode', width: 110, },
            { title: '配件名称', field: 'partsName', width: 110, },
            { title: '安装时间', field: 'instDate', width: 110, },
            { title: '供应商编码', field: 'supplierCode', width: 110, },
            { title: '供应商名称', field: 'supplierName', width: 110, },
            { title: '生产批次', field: 'supplierProduceNo', width: 100, },
            { title: '序列号', field: 'produceNoSeq', width: 110, },
            // { title: '销售区域名称', field: 'saleOrgName', width: 110, },
          ]
        },
        // {
        //   title: '',
        //   children: [
        //     // { title: '销售单号', field: 'encoding', width: 80, },
        //     // { title: '销售商', field: 'supply', width: 80, },
        //     { title: '销售日期', field: 'instDate', width: 100 },
        //   ]
        // },

      ],
    };
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    // activeName(newVal) {
    //   if (newVal === 'second' && this.editViewDataUpdateFlag) {
    //     this.getTableData()
    //   }
    // }
  },
  created() {
    this.item_barcode_search_report_export = this.permissions['item_barcode_search_report_export']
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    //导出
    doExcel(){
      this.$mask.open()
      doCheckExcle(fileNames.barcodeSearchReport).then(response => {
        if (response.data.msg=="success"){
          doDownLoadExcle(api.itemBarcodeSearchReport.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          }).catch(() => {
            this.$mask.close()
          })
        }else{
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },

    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      const fields = ['produceNo', 'produceCompany', 'itemCode', "itemName", 'produceNo', 'produceLine']
      const cellValue = row[column.property]
      if (cellValue && fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.itemBarcodeSearchReport.getPage,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      // this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.searchBarcode = ''
      this.searchItemName = ''
      this.searchItemCode = ''
      this.requestParam.searchCount = false
      this.requestParam.barcode = ''
      this.requestParam.itemCode = ''
      this.requestParam.itemName = ''
      this.requestParam.current = 1
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      console.log(id)
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    // editViewDataUpdate() {
    //   this.editViewDataUpdateFlag = true;
    // },
  }
};
</script>
<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
